"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fail = exports.ok = exports.ApiResponseSchema = void 0;
const zod_1 = require("zod");
const ApiResponseSchema = (data) => zod_1.z.object({
    code: zod_1.z.number(),
    data: data.nullable(),
    msg: zod_1.z.string(),
});
exports.ApiResponseSchema = ApiResponseSchema;
const ok = (data, msg = "OK") => ({
    code: 200,
    data,
    msg,
});
exports.ok = ok;
const fail = (code, msg) => ({
    code,
    data: null,
    msg,
});
exports.fail = fail;
